/* eslint-disable react/prop-types */
import { Col, Descriptions, Row, Statistic } from "antd";

const StatisticCard = ({
  title1,
  title2,
  statics1,
  statics2,
  formatter,
  description,
}) => {
  return (
    <Row gutter={16} justify={"center"}>
      <Col span={12}>
        <Statistic title={title1} value={statics1} formatter={formatter} />
      </Col>
      <Col span={12}>
        <Statistic title={title2} value={statics2} formatter={formatter} />
      </Col>
      {/* new changes - tag v3.0.1 */}
      <Col span={24}>
        <Descriptions title="" items={[description[0]]} />
      </Col>
      <Col span={24}>
        <Descriptions title="" items={[description[1]]} />
      </Col>
    </Row>
  );
};

export default StatisticCard;
